import React from 'react';
import PropTypes from 'prop-types';
import { graphql, QueryRenderer } from 'react-relay';
import UserPlaylistRenderer from './UserPlaylistRenderer';

const UserPlaylistContext = React.createContext();

export const UserPlaylistConsumer = UserPlaylistContext.Consumer;

const UserPlaylistQuery = ({ playlistId, ...props }) => (
  <UserPlaylistContext.Provider value={props}>
    <QueryRenderer
      environment={props.relay.environment}
      query={graphql`
        query UserPlaylistQuery_Query($id: ID!, $query: String!) {
          node(id: $id) {
            ... on Playlist {
              ...UserPlaylistContainer_node
              ...RecommendationContainer_node
            }
          }
        }
      `}
      variables={{
        id: playlistId,
        query: ''
      }}
      render={UserPlaylistRenderer}
    />
  </UserPlaylistContext.Provider>
);

UserPlaylistQuery.propTypes = {
  relay: PropTypes.object.isRequired,
  playlistId: PropTypes.string.isRequired
};

export default UserPlaylistQuery;



// WEBPACK FOOTER //
// ./webpack/components/App/UserPlaylistQuery.js